import { EffectType } from '@devvit/protos/json/devvit/ui/effects/v1alpha/effect.js';
import { WebViewInternalMessageScope, } from '@devvit/protos/json/devvit/ui/effects/web_view/v1alpha/post_message.js';
/** `WebViewInternalMessage.type`. */
export const webViewInternalMessageType = 'devvit-internal';
/**
 * Emits an effect to the parent window returns immediately.
 *
 * @param effect - The effect to be emitted to the parent window
 * @param requestId - Optional request id used to correlate request/response messages
 * @description
 * This function handles effects that don't require a response, and can also
 * set a request id when replying to client-originated requests.
 */
export const emitEffect = (effect, requestId) => {
    const message = {
        ...effect,
        realtimeEffect: effect.realtime, // to-do: remove deprecated field.
        id: requestId,
        scope: WebViewInternalMessageScope.CLIENT,
        type: webViewInternalMessageType,
    };
    // For temporary backward compatibility, we set both `message.effect_type` above, and `effect` below
    // Once mobile clients are updated to consume the strongly typed properties above, we can remove this block
    // *Do not* add new effects here, use the strongly typed properties above
    if (effect.showToast || effect.navigateToUrl) {
        message.effect = effect;
    }
    parent.postMessage(message, '*');
};
/**
 * Emits an effect to the parent window and returns a promise that resolves with the response message.
 *
 * @param effect - The effect to be emitted to the parent window
 * @returns A promise that resolves with the response message
 *
 * @description
 * This function handles effects that require a response.
 */
export const emitEffectWithResponse = (effect) => {
    return new Promise((resolve) => {
        const message = {
            ...effect,
            realtimeEffect: effect.realtime, // to-do: remove deprecated field.
            scope: WebViewInternalMessageScope.CLIENT,
            type: webViewInternalMessageType,
        };
        // For temporary backward compatibility, we set both `message.effect_type` above, and `effect` below
        // Once mobile clients are updated to consume the strongly typed properties above, we can remove this block
        // *Do not* add new effects here, use the strongly typed properties above
        if (effect.showForm || effect.type === EffectType.EFFECT_CAN_RUN_AS_USER) {
            message.effect = effect;
        }
        const id = crypto.randomUUID();
        message.id = id;
        const handleEffect = (event) => {
            if (event.data?.type === 'devvit-message' && event.data?.data?.id === id) {
                resolve(event.data.data);
                removeEventListener('message', handleEffect);
            }
        };
        addEventListener('message', handleEffect);
        // Post message to the parent window, handled by client web view component
        parent.postMessage(message, '*');
    });
};
